<div class="loading-wrapper">
  <mat-spinner diameter="32"></mat-spinner>
</div>
